<template>

    <form-with-base-message v-if="$route.query.token" ref="form"
                            :base-errors="getErrorForField('base')"
                            class="container_form"
                            :success-message="successMessage">

        <v-container fluid>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-text-field
                            autocomplete="new-password"
                            v-model="password"
                            :placeholder="$vuetify.t('$vuetify.NewPassword.passwordPlaceholder')"
                            background-color="primary"
                            color="seconary"
                            solo
                            name="username"
                            type="password"
                            :error-messages="getErrorForField('password')"
                            @focus="resetErrorForField('password')"
                    ></v-text-field>
                    <v-text-field
                            autocomplete="new-password"
                            v-model="passwordConfirmation"
                            :placeholder="$vuetify.t('$vuetify.NewPassword.passwordConfirmationPlaceholder')"
                            background-color="primary"
                            color="seconary"
                            solo
                            name="username"
                            type="password"
                            :error-messages="getErrorForField('password_confirmation')"
                            @focus="resetErrorForField('password_confirmation')"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-btn block class="eco-button"
                           color="button-light"
                           type="submit"
                           large
                           @click.prevent="requestNewPassword()">
                        {{$vuetify.t('$vuetify.NewPassword.changePassword')
                        | uppercase }}
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>

    </form-with-base-message>

    <v-container v-else fluid>
        <v-layout row wrap>
            <v-flex xs12>
                {{ $vuetify.t("$vuetify.NewPassword.noTokenError")}}
            </v-flex>
        </v-layout>
    </v-container>


</template>


<script>
    import FormWithBaseMessage from "../components/FormWithBaseMessage"
    import formValidation from "../mixins/formValidation"


    export default {
        data: function () {

            return {

                password: "",
                passwordConfirmation: "",
                successMessage: {}
            }
        },
        mixins: [formValidation],
        methods: {
            requestNewPassword() {

                if (this.password === this.passwordConfirmation) {
                    const NEW_PASSWORD_MUTATION = require("../graphql/mutations/newPassword.gql")
                    this.$apollo.mutate({
                        client: "clientPublic",
                        // Query
                        mutation: NEW_PASSWORD_MUTATION,
                        // Parameters
                        variables: {
                            password: this.password,
                            token: this.$route.query.token

                        },

                    }).then((result) => {

                        result = result.data.passwordResetWithToken

                        if (result._response.result) {
                            this.errors = []
                            this.$refs.form.resetForm()
                            this.successMessage =
                                {
                                    title: this.$vuetify.t("$vuetify.NewPassword.successPasswordChangedTitle"),
                                    text: this.$vuetify.t("$vuetify.NewPassword.successPasswordChanged")
                                }
                            setTimeout(() => {
                                this.$router.push({name: "login"})
                            }, 3200)

                        } else {
                            this.errors = this.collectErrors(result._response.errors, "NewPassword")

                        }


                    }).catch((error) => {

                        //TODO implementare default error catcher
                        // Error
                        console.error(error)

                    })

                } else {
                    this.$set(this.errors,"password",this.$vuetify.t("$vuetify.NewPassword.errors.password.must_same_password_confirm"))

                }

            }

        },
        components: {
            FormWithBaseMessage
        }


    }
</script>


<style scoped lang="scss">

    .container_form {
        height: 350px;
        margin: auto 30px !important;

    }


</style>
